import {newvioGradient} from '@findhotel/atlas-tokens'

export const gradients = newvioGradient?.gradient
